import { FormModal } from "../base";
import { ErrorFallbackConfigForm, ErrorFallbackConfigFormData } from "./ErrorFallbackConfigForm";

type ErrorFallbackSettingsDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  config: ErrorFallbackConfigFormData;
  onSave: (config: ErrorFallbackConfigFormData) => void;
};

export const ErrorFallbackSettingsDialog = ({ isOpen, onClose, config, onSave }: ErrorFallbackSettingsDialogProps) => {
  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      config={config}
      title="Error Fallback Settings"
      saveLabel="Save & Deploy"
      className="w-full max-w-[600px] min-w-0 max-h-[90vh] mx-4"
    >
      {({ localConfig, onChange }) => (
        <ErrorFallbackConfigForm
          config={localConfig}
          onChange={onChange}
        />
      )}
    </FormModal>
  );
};
